import { Typography } from '@occc-app/design-system';

import { formatPointChange } from '../membership-activity.utils';

type MembershipActivityPointChangeProps = {
  amount: number;
};

export const MembershipActivityPointChange = ({ amount }: MembershipActivityPointChangeProps) => {
  return (
    <Typography
      component='span'
      variant='body2'
      sx={{
        color: amount > 0 ? 'success.main' : amount < 0 ? 'error.main' : undefined,
      }}
    >
      {formatPointChange(amount)}
    </Typography>
  );
};
